<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="columns is-multiline">
            <div v-if="banners.length">
                <div v-for="x in banners"  :key="x.id" class="column is-two-thirds m-b-20" style="border-bottom:#4d4d4d solid 0.8px;">
                    <a @click="deleteBanner(x.id)" class="has-text-danger">
                        <b-icon icon="trash" size="is-small"></b-icon>
                        Delete
                    </a>
                    <b-field label="Visible">
                        <b-switch
                        v-model="x.display"
                        @input="updateBanner(x)">
                        </b-switch>
                    </b-field>
                    <b-field label="Ancho total">
                        <b-switch
                        v-model="x.fullWidth"
                        @input="updateBanner(x)">
                        </b-switch>
                    </b-field>
                    <img :src="x.image" class="banner">
                    <br>
                    <a target="_blank" :href="x.link" class="has-text-primary">Link del banner</a>
                </div>
            </div>
            <div v-else class="column is-full">
                <h1 class="has-text-weight-semibold is-size-3">Todavia no creaste ningun banner.</h1>
            </div>
            <div class="column is-full m-t-30 has-text-centered">
                <b-button
                type="is-primary"
                rounded
                @click="createModal=true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Agregar banners
                </b-button>
            </div>
        </div>

        <b-modal :active.sync="createModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body">

                    <div class="columns is-multiline">
                        <div class="column is-full">
                            <b-field label="Banner">
                                <b-upload
                                    v-model="uploadImage"
                                    drag-drop
                                    @input="encodeImage"
                                >
                                <section class="section" >
                                    <div class=" has-text-centered">
                                        <p>
                                            <b-icon
                                                icon="upload"
                                                size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Arrastra tus archivos aqui o haz click.</p>
                                    </div>
                                </section>
                                </b-upload>
                            </b-field>
                            <div v-if="uploadImage" class="tags">
                                <span
                                    class="tag is-primary" >
                                    {{uploadImage.name}}
                                    <button class="delete is-small"
                                        type="button"
                                        @click="deleteDropFile">
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div class="column is-full">
                            <b-field label="Todo el ancho">
                                <b-switch
                                v-model="newBanner.fullWidth">
                                </b-switch>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field label="Link">
                                <b-input
                                v-model="newBanner.link">
                                </b-input>
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-full has-text-centered">
                            <b-button
                            @click="createBanner"
                            type="is-primary"
                            rounded>
                                <b-icon icon="save" size="is-small"></b-icon>
                                Crear banner
                            </b-button>
                        </div>
                    </div>

                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getHandler, deleteHandler, postHandler, patchHandler } from '../../../../services/http'
export default {
    props:{
        bannerCreate:{
            type:String,
            default:""
        },
        bannerList:{
            type:String,
            default:""
        },
        bannerDetail:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            banners:[],
            loading:false,
            createModal:false,
            uploadImage:"",
            newBanner:{
                image:"",
                link:"",
                fullWidth:false
            }
        }
    },
    methods:{
        async fetchBanners(){
            this.loading = true
            this.banners = await getHandler(this.bannerList, {error:false, success:false})
            this.loading = false
        },
        async deleteBanner(id){
            let msg={
                resource:"notify"
            }
            let url = this.bannerDetail.replace("0000", id)
            this.resp = await deleteHandler(url, {error:msg, success:msg})
            this.fetchBanners()
        },
        async createBanner(){
            let msg={
                resource:"notify"
            }
            this.resp = await postHandler(this.bannerCreate, this.newBanner, {error:msg, success:msg})
            this.newBanner = {
                image:"",
                link:"",
                fullWidth:false
            }
            this.uploadImage = ""
            this.fetchBanners()
        },
        async updateBanner(x){
            let msg={
                resource:"notify"
            }
            let url = this.bannerDetail.replace("0000", x.id)
            this.resp = await patchHandler(url, x, {error:msg, success:msg})

        },

        encodeImage(){
            let reader = new FileReader();
            reader.readAsDataURL(this.uploadImage);
            reader.onloadend = (event) => {
                this.newBanner.image = reader.result
            }
        },
        deleteDropFile(){
            this.uploadImage = ""
            this.newBanner.image = ""
        },

    },
    created(){
        this.fetchBanners()
    }
}
</script>

<style lang="scss" scoped>
.banner{
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>